export const SET_WIDGET_TITLE = 'setWidgetTitle';
export const GET_RING_TREES = 'getRingTrees';
export const GET_RING_TREE = 'getRingTree';
export const GET_RING_TREE_TARGETS = 'getRingTreeTargets';
export const GET_RING_TREESS_STATS = 'getRingTreesStats';
export const CREATE_RING_TREE = 'createRingTree';
export const UPDATE_RING_TREE = 'updateRingTree';
export const UPDATE_RING_TREE_PROPERTY = 'updateRingTreeProperty';
export const DELETE_RING_TREE = 'deleteRingTree';
export const GET_USER_VISIBLE_COLUMNS = 'getUserVisibleColumns';
export const GET_RING_TREE_REFERENCES = 'getRingTreeReferences';
